export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-message-history": { "delivery-status": { "READ": "Read at {{ timestamp }}", "SENT": "Sent at {{ timestamp }}" } } } });
};